import { render, staticRenderFns } from "./Dm.vue?vue&type=template&id=6c088704&scoped=true"
import script from "./Dm.vue?vue&type=script&lang=js"
export * from "./Dm.vue?vue&type=script&lang=js"
import style0 from "./Dm.vue?vue&type=style&index=0&id=6c088704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c088704",
  null
  
)

export default component.exports